import React, { useState, useEffect, createContext, useContext } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, Switch, Route } from 'react-router-dom'
import { articlesApi } from '../../../api/articlesApi'
import Search from '../../common/Search'
import ProductCard from './ProductCard'
import FolderProduct from './FolderProduct'
import LoadingSpinner from '../../common/LoadingSpinner'
import {
  Breadcrumb,
  HeaderBreadcrumb,
  BreadcrumbPortal,
} from '../../common/Breadcrumb'
import Header from '../../header/Header'
import NullMssg from '../../common/NullMssg'
import FinalProductContainer from '../../final-product/FinalProductConainer'
import { mssgs } from '../../../constantes/mssgs'
import '../../../assests/styles/catalogue/CatalogueCards.scss'
import '../../../assests/styles/catalogue/NodesV2.scss'
import { BusinessUnitMultiSelect } from '../../fields'
import { set } from 'lodash'

const BusinessUnitsContext = createContext()
export const useBusinessUnits = () => useContext(BusinessUnitsContext)

export const BusinessUnitsProvider = ({ children }) => {
  const [filterBusinessUnits, setFilterBusinessUnits] = useState([])
  const [filterBusinessUnitsString, setFilterBusinessUnitsString] = useState("")

  useEffect(() => {
    setFilterBusinessUnitsString(filterBusinessUnits.join(","))
    // setAllCategories(
    //   filterBusinessUnits.length === 0
    //   ? [...allCategoriesOriginal]
    //   : allCategoriesOriginal.filter(category =>
    //     filterBusinessUnits.includes(category.id_NegocioUnidades)
    //     )
    // )
  }, [filterBusinessUnits])

  return (
    <BusinessUnitsContext.Provider value={{ filterBusinessUnits, setFilterBusinessUnits, filterBusinessUnitsString, setFilterBusinessUnitsString, setFilterBusinessUnitsString }}>
      {children}
    </BusinessUnitsContext.Provider>
  )
}

const CatalogContainerComponent = ({ filterBusinessUnits, setFilterBusinessUnits, onChangeSearch, children }) => {
  return (
    <div className='container-fluid m-0 p-0'>
      <div className='row'>

        <div className="col-sm-12 col-xl-8 justify-content-start d-flex">
      
          <HeaderBreadcrumb>
            <BreadcrumbPortal />
          </HeaderBreadcrumb>

        </div>

        <div className="col-sm-12 col-xl-4 justify-content-end d-flex">

            <div className="w-100 d-flex flex-wrap">

              <div style={{ marginRight: "1rem", marginBottom: "0.5rem" }}>

                <BusinessUnitMultiSelect
                  size='xl'
                  value={filterBusinessUnits}
                  onChange={setFilterBusinessUnits}
                  placeholder='Selecciona las unidades de negocio...'
                  compact
                />

              </div>

              <Search
                onChangeSearch={onChangeSearch}
                placeholder='Buscar productos...'
              />

          </div>

        </div>
      </div>
      <div className="row">

        <div className="col-12">

          {children}

        </div>

      </div>
    </div>
  );

}

// Nivel 1. Categorías con búsqueda global recursiva
const NodesV2 = () => {
  const history = useHistory()
  // 20251114: No podemos obtener todas las categorías. Debemos filtrar por unidad de negocio
  const allCategoriesOriginal = useSelector((state) => state.categories)
  // const allCategoriesOriginal = useState([])
  const [items, setItems] = useState([])
  const [isSearching, setIsSearching] = useState(false)
  const [searchResults, setSearchResults] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [allCategories, setAllCategories] = useState([...allCategoriesOriginal])

  const { filterBusinessUnits, setFilterBusinessUnits } = useContext(BusinessUnitsContext)
  const { filterBusinessUnitsString, setFilterBusinessUnitsString } = useContext(BusinessUnitsContext)

  useEffect(() => {
    console.log("NodesV2.useEffect")
  }, [])

  useEffect(() => {
    // console.log("useEffect", allCategories);
    setItems(allCategories)
  }, [allCategories])

  useEffect(() => {
    // console.log("useEffect", filterBusinessUnits);
    setAllCategories(
      filterBusinessUnits.length === 0
      ? [...allCategoriesOriginal]
      : allCategoriesOriginal.filter(category =>
        Array.isArray(category.id_NegocioUnidades)
          ? category.id_NegocioUnidades.some(id => filterBusinessUnits.includes(id))
          : filterBusinessUnits.includes(category.id_NegocioUnidades)
        )
    )
  }, [filterBusinessUnits])

  // Función recursiva para buscar en todos los niveles
  const searchInAllLevels = async (value, visited = new Set()) => {
    console.log("NodesV2.searchInAllLevels", value);
    const searchRecursively = async (parentId = null, isCategory = false) => {
      console.log("NodesV2.searchInAllLevels.searchRecursively", parentId, isCategory);
      try {
        const response = isCategory
          ? await articlesApi.getArticlesByCategoryId(parentId, filterBusinessUnitsString)
          : parentId
          ? await articlesApi.getArticlesOfAFatherId(parentId, filterBusinessUnitsString)
          : { data: [] }

        const items = response && response.data ? response.data : []

        // Filtrar items que coinciden con la búsqueda y son únicos
        const matchingItems = items.filter((item) =>
          item.nombre.toLowerCase().includes(value.toLowerCase()),
        )

        const newItems = matchingItems.filter((item) => {
          const itemId = item.id_Articulo || item.id_TipoCategoria
          if (itemId && !visited.has(itemId)) {
            visited.add(itemId)
            return true
          }
          return false
        })

        // Buscar recursivamente en subcategorías
        const subcategories = items.filter(
          (item) => item.id_Articulo && item.isArticuloFinal !== true,
        )

        const childResults = await Promise.all(
          subcategories.map((item) =>
            searchRecursively(item.id_Articulo, false),
          ),
        )

        return [...newItems, ...childResults.flat()]
      } catch (error) {
        console.warn(`Error buscando en nivel ${parentId}:`, error)
        return []
      }
    }

    const categoryResults = await Promise.all(
      allCategories.map((category) =>
        searchRecursively(category.id_TipoCategoria, true),
      ),
    )

    return categoryResults.flat()
  }

  const onChangeSearch = async (value) => {
    console.log("NodesV2.onChangeSearch", value);
    if (!value || value.trim() === '') {
      setIsSearching(false)
      setIsLoading(false)
      setSearchResults([])
      setItems(allCategories)
      return
    }

    setIsSearching(true)
    setIsLoading(true)

    try {
      // Búsqueda local en categorías principales
      const filteredCategories = allCategories.filter((item) =>
        item.nombre.toLowerCase().includes(value.toLowerCase()),
      )

      // Búsqueda recursiva en todos los niveles
      const recursiveResults = await searchInAllLevels(value)

      // Búsqueda global de productos
      const [finalProductsResponse, folderProductsResponse] = await Promise.all(
        [
          articlesApi.getAllFinalProductsBySearch(value, 0, filterBusinessUnitsString),
          articlesApi.getAllFolderProductsBySearch(value, 0, filterBusinessUnitsString),
        ],
      )

      const finalProducts =
        finalProductsResponse && finalProductsResponse.data
          ? finalProductsResponse.data
          : []
      const folderProducts =
        folderProductsResponse && folderProductsResponse.data
          ? folderProductsResponse.data
          : []

      // Combinar productos globales y eliminar duplicados
      const globalProducts = [...finalProducts, ...folderProducts]
      const visitedIds = new Set(
        recursiveResults.map(
          (item) => item.id_Articulo || item.id_TipoCategoria,
        ),
      )

      const uniqueGlobalProducts = globalProducts.filter((product) => {
        const productId = product.id_Articulo || product.id_TipoCategoria
        if (!visitedIds.has(productId)) {
          visitedIds.add(productId)
          return true
        }
        return false
      })

      // Eliminar categorías principales duplicadas
      const categoriesVisited = new Set(
        recursiveResults.map((item) => item.id_TipoCategoria).filter(Boolean),
      )
      const uniqueFilteredCategories = filteredCategories.filter((category) => {
        return !categoriesVisited.has(category.id_TipoCategoria)
      })

      // Combinar todos los resultados
      const allResults = [
        ...uniqueFilteredCategories,
        ...recursiveResults,
        ...uniqueGlobalProducts,
      ]

      setSearchResults(allResults)
    } catch (error) {
      console.error('Error en búsqueda global:', error)
      // Fallback a búsqueda local
      const filteredItems = allCategories.filter((item) =>
        item.nombre.toLowerCase().includes(value.toLowerCase()),
      )
      setSearchResults(filteredItems)
    } finally {
      setIsLoading(false)
    }
  }

  // Función helper para renderizar un item
  const renderItem = (item, index) => {
    const itemKey = isSearching
      ? `search-${item.id_Articulo || item.id_TipoCategoria}-${index}`
      : `item-${item.id_TipoCategoria}-${index}`

    if (isSearching) {
      // Lógica para búsqueda global
      if (item.id_TipoCategoria && !item.id_Articulo) {
        // Categoría principal
        return (
          <FolderProduct
            key={itemKey}
            item={item}
            pathname={`/catalogo-v2/categoria/${item.id_TipoCategoria}`}
          />
        )
      } else if (item.id_Articulo && item.isArticuloFinal === true) {
        // Producto final
        return (
          <ProductCard
            key={itemKey}
            item={item}
            pathname={`/catalogo-v2/producto-final/${item.id_Articulo}`}
          />
        )
      } else if (item.id_Articulo) {
        // Subcategoría/producto folder
        return (
          <FolderProduct
            key={itemKey}
            item={item}
            pathname={`/catalogo-v2/producto/${
              item.id_Articulo
            }/${item.nombre.replace(/ *\([^)]*\) */g, '')}`}
          />
        )
      } else {
        // Fallback
        return <FolderProduct key={itemKey} item={item} pathname={`#`} />
      }
    }

    // Lógica para categorías normales (sin búsqueda)
    return item.isArticuloFinal === true ? (
      <ProductCard
        key={itemKey}
        item={item}
        pathname={`/catalogo-v2/producto-final/${item.id_Articulo}`}
      />
    ) : (
      <FolderProduct
        key={itemKey}
        item={item}
        pathname={`/catalogo-v2/categoria/${item.id_TipoCategoria}`}
      />
    )
  }

  const itemsToShow = isSearching ? searchResults : items

  return (
    <>
      <Breadcrumb to={`/catalogo-v2`}>Catálogo - Búsqueda Global</Breadcrumb>
      <Switch>
        <Route
          path={`/catalogo-v2/categoria/:id`}
          component={ProductsOfACategoryV2}
        />
        <Route
          path={`/catalogo-v2/producto-final/:id`}
          component={DirectFinalProductV2}
        />
        <Route
          path={`/catalogo-v2/producto/:idProduct/:nombre`}
          component={DirectProductV2}
        />

        <Route>
          <Header
            text={'Catálogo - Búsqueda Global'}
            route={() => history.goBack()}
            backBtn={true}
          />

          <CatalogContainerComponent
            filterBusinessUnits={filterBusinessUnits}
            setFilterBusinessUnits={setFilterBusinessUnits}
            onChangeSearch={onChangeSearch}
          >
            {isLoading ? (
              <LoadingSpinner
                message='Buscando en todos los niveles...'
                size='large'
                variant='primary'
              />
            ) : itemsToShow.length > 0 ? (
              <div className='catalogue-grid'>
                {itemsToShow.map((item, index) => renderItem(item, index))}
              </div>
            ) : (
              <div className='catalogue-no-results'>
                <div className='no-results-content'>
                  <div className='no-results-icon'>🔍</div>
                  <div className='no-results-text'>
                    {isSearching
                      ? 'No se encontraron resultados'
                      : 'No hay productos disponibles'}
                  </div>
                </div>
              </div>
            )}
          </CatalogContainerComponent>

        </Route>
      </Switch>
    </>
  )
}

// Nivel 2: Productos de una categoria V2
const ProductsOfACategoryV2 = ({ match }) => {
  const id = match.params.id
  const history = useHistory()

  const allCategoriesOriginal = useSelector((state) => state.categories)
  const [allCategories, setAllCategories] = useState([...allCategoriesOriginal])

  const [items, setItems] = useState([])
  const [data, setData] = useState([])

  const { filterBusinessUnits, setFilterBusinessUnits } = useContext(BusinessUnitsContext)
  const { filterBusinessUnitsString, setFilterBusinessUnitsString } = useContext(BusinessUnitsContext)

  const CATEGORY_BY_ID = allCategories.reduce(
    (accumulator, category) => ({
      ...accumulator,
      [category.id_TipoCategoria]: category,
    }),
    {},
  )

  const category = CATEGORY_BY_ID[id]

  useEffect(() => {
    searchItemsNextNode()
  }, [])

  useEffect(() => {
    // console.log("useEffect", allCategories);
    setItems(allCategories)
    searchItemsNextNode()
  }, [allCategories])

  useEffect(() => {
    // console.log("useEffect", filterBusinessUnits);
    setAllCategories(
      filterBusinessUnits.length === 0
      ? [...allCategoriesOriginal]
      : allCategoriesOriginal.filter(category =>
        Array.isArray(category.id_NegocioUnidades)
          ? category.id_NegocioUnidades.some(id => filterBusinessUnits.includes(id))
          : filterBusinessUnits.includes(category.id_NegocioUnidades)
        )
    )
  }, [filterBusinessUnits])

  const searchItemsNextNode = async () => {
    console.log("ProductsOfACategoryV2.searchItemsNextNode", filterBusinessUnitsString);
    try {
      // console.log('searchItemsNextNode')
      const response = await articlesApi.getArticlesByCategoryId(id, filterBusinessUnitsString)

      // No filtrar para poder visualizar productos finales sin subfamilia
      //const folderProducts = response.data.filter(item => item.isArticuloFinal === false)
      const folderProducts = response.data
      // const finalProducts = response.data.filter(item => item.isArticuloFinal === true)
      const orderedItems = [...folderProducts]

      // console.log('orderedItems', orderedItems)

      setData(orderedItems)
      setItems(orderedItems)

      // setData(response.data)
      // setItems(response.data)
    } catch (error) {
      history.goBack()
    }
  }

  const onChangeSearch = (value) => {
    console.log("ProductsOfACategoryV2.onChangeSearch", value);
    const newItems = data.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      <Breadcrumb to={match.url}>
        {category && category.nombre ? category.nombre : 'Categoría'}
      </Breadcrumb>
      <Switch>
        <Route
          path={`${match.url}/product/:idProduct/:nombre`}
          component={ProductsV2}
        />
        <Route
          path={`${match.url}/final/:finalProduct`}
          component={FinalProductV2}
        />
        <Route>
          <Header
            text={'Catálogo'}
            route={() => history.goBack()}
            backBtn={true}
          />
          
          {/* <div className='catalogue-container'>
            <div className='catalogue-header'>
              <div className='filter__wrap-right mb-80'>
                <div className="row"> */}


                  <CatalogContainerComponent
                    filterBusinessUnits={filterBusinessUnits}
                    setFilterBusinessUnits={setFilterBusinessUnits}
                    onChangeSearch={onChangeSearch}
                  >

                    {items.length > 0 ? (
                      <div className='catalogue-grid'>
                        {items.map((item) =>
                          item.isArticuloFinal === false && (
                            <FolderProduct
                              key={`products-category-${item.id_Articulo}`}
                              item={item}
                              pathname={`${match.url}/product/${
                                item.id_Articulo
                              }/${item.nombre.replace(/ *\([^)]*\) */g, '')}`}
                            />
                          )
                        )}
                        {items.map((item) =>
                          item.isArticuloFinal === true && (
                            <ProductCard
                              key={`products-category-${item.id_Articulo}`}
                              item={item}
                              pathname={`${match.url}/final/${item.id_Articulo}`}
                            />
                          )
                        )}
                      </div>
                    ) : (
                      <div className='catalogue-no-results'>
                        <div className='no-results-content'>
                          <div className='no-results-icon'>🔍</div>
                          <div className='no-results-text'>
                            No hay productos disponibles
                          </div>
                        </div>
                      </div>
                    )}

                  </CatalogContainerComponent>

                {/* </div>
              </div>
            </div>
          </div> */}
        </Route>
      </Switch>
    </>
  )
}

// Nivel 2 + N: Productos de productos V2
const ProductsV2 = ({ match }) => {
  const id = match.params.idProduct
  const nombre = match.params.nombre

  const history = useHistory()
  const [items, setItems] = useState([])
  const [data, setData] = useState([])

  const { filterBusinessUnits, setFilterBusinessUnits } = useContext(BusinessUnitsContext)
  const { filterBusinessUnitsString, setFilterBusinessUnitsString } = useContext(BusinessUnitsContext)

  useEffect(() => {
    // console.log("useEffect", "match", match);
    searchItemsNextNode()
  }, [])

  useEffect(() => {
  }, [filterBusinessUnits])
  useEffect(() => {
    // console.log("ProductsV2", "useEffect", filterBusinessUnitsString);
    searchItemsNextNode()
  }, [filterBusinessUnitsString])

  const searchItemsNextNode = async () => {
    try {
      console.log('ProductsV2.searchItemsNextNode')
      const response = await articlesApi.getArticlesOfAFatherId(id, filterBusinessUnitsString)
      setData(response.data)
      setItems(response.data)
    } catch (error) {
      history.goBack()
    }
  }

  const onChangeSearch = (value) => {
    console.log('ProductsV2.onChangeSearch')
    const newItems = data.filter((item) => 
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      <Breadcrumb to={match.url}> {nombre} </Breadcrumb>
      <Switch>
        <Route
          path={`${match.url}/product/:idProduct/:nombre`}
          component={ProductsV2}
        />
        <Route
          path={`${match.url}/final/:finalProduct`}
          component={FinalProductV2}
        />
        <Route>
          <Header
            text={'Catálogo'}
            route={() => history.goBack()}
            backBtn={true}
          />

          <CatalogContainerComponent
            filterBusinessUnits={filterBusinessUnits}
            setFilterBusinessUnits={setFilterBusinessUnits}
            onChangeSearch={onChangeSearch}
          >
            {items.length > 0 ? (
              <div className='catalogue-grid'>
                {items.map((item) =>
                  item.isArticuloFinal === false && (
                    <FolderProduct
                      key={`products-v2-${item.id_Articulo}`}
                      item={item}
                      pathname={`${match.url}/product/${
                        item.id_Articulo
                      }/${item.nombre.replace(/ *\([^)]*\) */g, '')}`}
                    />
                    
                  )
                  )}
                  {items.map((item) =>
                  item.isArticuloFinal === true && (
                    <ProductCard
                      key={`products-v2-${item.id_Articulo}`}
                      item={item}
                      pathname={`${match.url}/final/${item.id_Articulo}`}
                    />
                  )
                )}
              </div>
            ) : (
              <div className='catalogue-no-results'>
                <div className='no-results-content'>
                  <div className='no-results-icon'>🔍</div>
                  <div className='no-results-text'>
                    No hay productos disponibles
                  </div>
                </div>
              </div>
            )}

          </CatalogContainerComponent>

        </Route>
      </Switch>
    </>
  )
}

const FinalProductV2 = ({ match }) => {
  const finalProduct = match.params.finalProduct
  const history = useHistory()
  const [item, setItem] = useState('')

  const [filterBusinessUnits, setFilterBusinessUnits] = useState([]);
  const { filterBusinessUnitsString, setFilterBusinessUnitsString } = useContext(BusinessUnitsContext)

  useEffect(() => {
    getInfoFinalProduct()
  }, [])

  const getInfoFinalProduct = async () => {
    try {
      const response = await articlesApi.getInfoArticle(finalProduct)
      setItem(response.data)
    } catch (error) {
      history.goBack()
    }
  }

  return (
    <>
      <Breadcrumb to={match.url}> </Breadcrumb>
      <Switch>
        <Route>
          <Header
            text={'Catálogo'}
            route={() => history.goBack()}
            backBtn={true}
          />
          <div className='filter__wrap-right mb-80'>
            <HeaderBreadcrumb>
              <BreadcrumbPortal />
            </HeaderBreadcrumb>
          </div>
          <FinalProductContainer item={item} />
        </Route>
      </Switch>
    </>
  )
}

// Componente para manejar productos finales directos desde búsqueda global V2
const DirectFinalProductV2 = ({ match }) => {
  const id = match.params.id
  const history = useHistory()
  const [item, setItem] = useState('')

  const { filterBusinessUnits, setFilterBusinessUnits } = useContext(BusinessUnitsContext)
  const { filterBusinessUnitsString, setFilterBusinessUnitsString } = useContext(BusinessUnitsContext)

  useEffect(() => {
    getInfoFinalProduct()
  }, [])

  const getInfoFinalProduct = async () => {
    try {
      const response = await articlesApi.getInfoArticle(id)
      setItem(response.data)
    } catch (error) {
      history.goBack()
    }
  }

  return (
    <>
      <Breadcrumb to={match.url}> </Breadcrumb>
      <Switch>
        <Route>
          <Header
            text={'Catálogo'}
            route={() => history.goBack()}
            backBtn={true}
          />
          <div className='filter__wrap-right mb-80'>
            <HeaderBreadcrumb>
              <BreadcrumbPortal />
            </HeaderBreadcrumb>
          </div>
          <FinalProductContainer item={item} />
        </Route>
      </Switch>
    </>
  )
}

// Componente para manejar productos folder directos desde búsqueda global V2
const DirectProductV2 = ({ match }) => {
  const productId = match.params.idProduct
  const nombre = match.params.nombre
  const history = useHistory()
  const [items, setItems] = useState([])
  const [data, setData] = useState([])

  const { filterBusinessUnits, setFilterBusinessUnits } = useContext(BusinessUnitsContext)
  const { filterBusinessUnitsString, setFilterBusinessUnitsString } = useContext(BusinessUnitsContext)

  useEffect(() => {
    searchItemsNextNode()
  }, [])

  const searchItemsNextNode = async () => {
    try {
      const response = await articlesApi.getArticlesOfAFatherId(productId, filterBusinessUnitsString)
      setData(response.data)
      setItems(response.data)
    } catch (error) {
      history.goBack()
    }
  }

  const onChangeSearch = (value) => {
    const newItems = data.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase()),
    )
    setItems(newItems)
  }

  return (
    <>
      <Breadcrumb to={match.url}>{nombre}</Breadcrumb>
      <Switch>
        <Route
          path={`${match.url}/product/:idProduct/:nombre`}
          component={DirectProductV2}
        />
        <Route
          path={`${match.url}/final/:finalProduct`}
          component={FinalProductV2}
        />
        <Route>
          <Header
            text={'Catálogo'}
            route={() => history.goBack()}
            backBtn={true}
          />
          <div className='catalogue-container'>
            <div className='catalogue-header'>
              <div className='filter__wrap-right mb-80'>
                <HeaderBreadcrumb>
                  <BreadcrumbPortal />
                </HeaderBreadcrumb>
                <div className='filter__wrap-right'>

                  <div style={{ marginTop: '14px', marginRight: '1rem'}}>
                    <BusinessUnitMultiSelect
                      value={filterBusinessUnits}
                      onChange={setFilterBusinessUnits}
                      // onChange={(selectedIds) => {
                      //   setFilterBusinessUnits(selectedIds);
                      // }}
                      label='Unidades de Negocio'
                      placeholder='Selecciona las unidades de negocio...'
                      compact
                    />
                  </div>

                  <Search
                    onChangeSearch={onChangeSearch}
                    placeholder='Buscar productos...'
                  />
                </div>
              </div>
            </div>
            <div>
              {items.length > 0 ? (
                <div className='catalogue-grid'>
                  {items.map((item) =>
                    item.isArticuloFinal === true ? (
                      <ProductCard
                        key={`direct-products-v2-${item.id_Articulo}`}
                        item={item}
                        pathname={`${match.url}/final/${item.id_Articulo}`}
                      />
                    ) : (
                      <FolderProduct
                        key={`direct-products-v2-${item.id_Articulo}`}
                        item={item}
                        pathname={`${match.url}/product/${
                          item.id_Articulo
                        }/${item.nombre.replace(/ *\([^)]*\) */g, '')}`}
                      />
                    ),
                  )}
                </div>
              ) : (
                <div className='catalogue-no-results'>
                  <div className='no-results-content'>
                    <div className='no-results-icon'>🔍</div>
                    <div className='no-results-text'>
                      No hay productos disponibles
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Route>
      </Switch>
    </>
  )
}

export default function NodesV2WithProvider(props) {
  return (
    <BusinessUnitsProvider>
      <NodesV2 {...props} />
    </BusinessUnitsProvider>
  );
}
